// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__bda3j","validationTips":"StatementDescriptor_validationTips__h7xOd"};